function hideAlertHandler () {
  
  const trigger = document.querySelectorAll('.js-close-alert')
  
  if (!trigger.length) return

  trigger.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      const target = e.currentTarget.closest('.js-alert')

      if (!target) return

      target.classList.add('hidden')

      $(target).delay(150).slideUp(300)
    })
  })
  
}

export { hideAlertHandler }